export const recordBossBattleRound = (previous, attack, counter) => ({
  rounds: (previous?.rounds || 0) + 1,
  biggestHit: Math.max(previous?.biggestHit || 0, attack.damage),
  prevented:
    (previous?.prevented || 0) +
    (counter.reductions || []).reduce(
      (sum, reduction) => sum + reduction.amount,
      0
    ) +
    (counter.decoyDamage || 0) +
    (counter.protocolPrevented || 0),
  cleanDefenses:
    (previous?.cleanDefenses || 0) +
    (counter.rawDamage > 0 && counter.damage === 0 ? 1 : 0),
});
